import img_1 from '../../../assets/images/wallpapers-mb/wallpaper-1-mb.png'
import img_2 from '../../../assets/images/wallpapers-mb/wallpaper-2-mb.png'
import img_3 from '../../../assets/images/wallpapers-mb/wallpaper-3-mb.png'
import img_4 from '../../../assets/images/wallpapers-mb/wallpaper-4-mb.png'
import img_5 from '../../../assets/images/wallpapers-mb/wallpaper-5-mb.png'
import img_6 from '../../../assets/images/wallpapers-mb/wallpaper-6-mb.png'
import img_7 from '../../../assets/images/wallpapers-mb/wallpaper-7-mb.png'
import img_8 from '../../../assets/images/wallpapers-mb/wallpaper-8-mb.png'

import img_1_pc from '../../../assets/images/wallpapers-desktop/wallpaper-1-pc.png'
import img_2_pc from '../../../assets/images/wallpapers-desktop/wallpaper-2-pc.png'
import img_3_pc from '../../../assets/images/wallpapers-desktop/wallpaper-3-pc.png'
import img_4_pc from '../../../assets/images/wallpapers-desktop/wallpaper-4-pc.png'
import img_5_pc from '../../../assets/images/wallpapers-desktop/wallpaper-5-pc.png'
import img_6_pc from '../../../assets/images/wallpapers-desktop/wallpaper-6-pc.png'
import img_7_pc from '../../../assets/images/wallpapers-desktop/wallpaper-7-pc.png'
import img_8_pc from '../../../assets/images/wallpapers-desktop/wallpaper-8-pc.png'

export const imagesWallpapers = [
  {
    desktop: img_1_pc,
    mobile: img_1,
  },
  {
    desktop: img_2_pc,
    mobile: img_2,
  },
  {
    desktop: img_3_pc,
    mobile: img_3,
  },
  {
    desktop: img_4_pc,
    mobile: img_4,
  },
  {
    desktop: img_5_pc,
    mobile: img_5,
  },
  {
    desktop: img_6_pc,
    mobile: img_6,
  },
  {
    desktop: img_7_pc,
    mobile: img_7,
  },
  {
    desktop: img_8_pc,
    mobile: img_8,
  },
]
